import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Y",
  "use": "Y-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Y\"><title>Y</title><path d=\"M12.1 12.2l2.7-5.5h2.1L13 14v4h-1.9v-4.1L7.2 6.6h2.1l2.8 5.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/Y.svg
// module id = zi+e
// module chunks = 6